<ng-template ixPageHeader>
  <ix-page-title-header>
    <ix-search-input [value]="filterString" (search)="filterUpdated($event)"></ix-search-input>
    <ix-table-columns-selector [columns]="columns" (columnsChange)="columnsChange($event)"></ix-table-columns-selector>

    <button *ixRequiresRoles="requiredRoles" mat-button color="primary" ixTest="add-task" (click)="add()">
      {{ 'Add' | translate }}
    </button>
  </ix-page-title-header>
</ng-template>

<ix-table2
  class="table"
  [ix-table2-empty]="!(dataProvider.currentPageCount$ | async)"
  [emptyConfig]="emptyService.defaultEmptyConfig(dataProvider.emptyType$ | async)"
>
  <thead
    ix-table-head
    [columns]="columns"
    [dataProvider]="dataProvider"
  ></thead>
  <tbody
    ix-table-body
    [columns]="columns"
    [dataProvider]="dataProvider"
    [isLoading]="dataProvider.isLoading$ | async"
  >
  </tbody>
</ix-table2>
<ix-table-pager [dataProvider]="dataProvider"></ix-table-pager>
